export function initLoadMore() {
    const button = document.querySelector('#load-more-post');
    const container = document.querySelector('.ajax-list');

    if (!button) return;

    button.addEventListener('click', () => {
        let page = parseInt(button.dataset.page);
        const max = parseInt(button.dataset.max);
        const postType = button.dataset.postType;

        // jeśli nie ma więcej stron — zakończ
        if (page >= max) {
            button.style.display = 'none';
            return;
        }

        // pokaż loader i zablokuj
        button.disabled = true;
        button.querySelector('.btn__loader').style.display = 'inline';

        fetch(`${myAjax.ajaxurl}?action=load_more_posts&page=${page + 1}&post_type=${postType}`)
            .then(response => response.text())
            .then(html => {
                container.insertAdjacentHTML('beforeend', html);
                button.dataset.page = page + 1;

                // schowaj loader, przywróć button
                button.disabled = false;
                button.querySelector('.btn__loader').style.display = 'none';

                // ukryj przycisk, jeśli to już ostatnia strona
                if (page + 1 >= max) button.style.display = 'none';
            })
            .catch(err => console.error(err));
    });
}